import { CheckoutPageMonthlyCombined } from "./CheckoutPageMonthlyCombined";

export function CheckoutPageMonthly() {
    return <CheckoutPageMonthlyCombined isInvite={false} />;
}